import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { WikiHelpLinkComponent } from '../../components/wiki-help-link/wiki-help-link.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    WikiHelpLinkComponent,
    TranslateModule
  ],
  exports: [
    DashboardComponent
  ]
})
export class DashboardModule { }
